module.exports = __webpack_public_path__ + "img/symbol_3.2e224661.png";